import React, { useContext } from 'react';
import { bool } from 'prop-types';
import { Button } from '@thd-olt-component-react/button';
import classNames from 'classnames';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { ProductPodGroupContext } from '../../ProductPodGroupContext';
import { ProductPodContext } from '../../ProductPodContext';

export const ProductSeeSimilarItems = ({ isMobileDoubleColumn, showSimilarInStock }) => {

  const {
    onSimilarItemsClick,
    hideSimilarItemLink,
    showSimilarItem,
    showSimilarItemButton
  } = useContext(ProductPodContext);

  const {
    handleProductPodExpansion
  } = useContext(ProductPodGroupContext);

  const {
    channel
  } = useContext(ExperienceContext);
  const similarButtonEnabled = !(isMobileDoubleColumn && !showSimilarItemButton) && !showSimilarInStock;
  const isMobile = channel === 'mobile';
  const SimilarInStockButton = classNames({
    'product-pod__customs--margin': similarButtonEnabled && isMobile,
    'similar-items-link': !similarButtonEnabled,
    'similar-items-link__caret': showSimilarInStock
  });

  const isOutOfStock = !showSimilarItem && hideSimilarItemLink;
  if (!showSimilarInStock && (isOutOfStock || !handleProductPodExpansion)) {
    return null;
  }
  if (showSimilarInStock && (!isOutOfStock || !handleProductPodExpansion)) {
    return null;
  }

  const similarItemBtnClick = () => onSimilarItemsClick(similarButtonEnabled || showSimilarInStock);
  const seeSimilarText = showSimilarInStock ? 'View' : 'See';

  return (
    <>
      <Button
        tag="a"
        className={SimilarInStockButton}
        link={!similarButtonEnabled}
        dark={similarButtonEnabled}
        outline={similarButtonEnabled}
        small={similarButtonEnabled && isMobile}
        onClick={similarItemBtnClick}
      >
        {similarButtonEnabled ? 'View Similar in Stock' : `${seeSimilarText} similar items`}
      </Button>
    </>
  );
};

ProductSeeSimilarItems.propTypes = {
  isMobileDoubleColumn: bool,
  showSimilarInStock: bool
};
ProductSeeSimilarItems.defaultProps = {
  isMobileDoubleColumn: false,
  showSimilarInStock: false
};
ProductSeeSimilarItems.displayName = 'ProductSeeSimilarItems';
